import React, { useMemo } from 'react';

import { LayoutItem } from '@blockworks/platform/api/research/studio';
import { Bit } from '@blockworks/ui/factory';

import { MarkdownRenderer } from '../../../markdown';
import { useDashboardGridContext } from '../../context';

import { GridItemSettings } from './grid-item-settings';

type MarkdownGridItemProps = { item: LayoutItem };

const MarkdownGridItem: React.FC<MarkdownGridItemProps> = ({ item }) => {
    const { isEditable } = useDashboardGridContext();
    const value = useMemo(() => item?.data?.value ?? '', [item?.data?.value]);

    return (
        <>
            {isEditable && (
                <Bit.div pos="absolute" top={2} right={2}>
                    <GridItemSettings itemId={item.i} />
                </Bit.div>
            )}
            <MarkdownRenderer.Wrapper withScroller>
                <MarkdownRenderer.Memoized markdown={value} />
            </MarkdownRenderer.Wrapper>
        </>
    );
};

export type { MarkdownGridItemProps };
export { MarkdownGridItem };
